/**
 * The site is one seven-bag.
 *
 * There are exactly seven tetrominoes and exactly seven sections, so each
 * section owns a piece and that piece's spot ink. This is the organising idea
 * behind the navigation, the section headers and the colour of every band.
 */

import type { PieceType } from "@/game/pieces";

export interface Section {
  readonly id: string;
  readonly piece: PieceType;
  /** Two-digit index, printed like a part number. */
  readonly index: string;
  readonly label: string;
  /** Short form for the navigation rail. */
  readonly short: string;
}

export const SECTIONS: readonly Section[] = [
  { id: "top", piece: "I", index: "00", label: "Tetris At UCI", short: "Top" },
  { id: "club", piece: "J", index: "01", label: "The Club", short: "Club" },
  { id: "meetings", piece: "L", index: "02", label: "Meetings", short: "Meet" },
  { id: "roster", piece: "O", index: "03", label: "The Roster", short: "Roster" },
  { id: "compete", piece: "S", index: "04", label: "Compete", short: "Compete" },
  { id: "projects", piece: "T", index: "05", label: "Projects", short: "Projects" },
  { id: "join", piece: "Z", index: "06", label: "Join Us", short: "Join" },
] as const;

export function sectionById(id: string): Section | undefined {
  return SECTIONS.find((section) => section.id === id);
}
